import { render } from "./LiabilityReport.vue?vue&type=template&id=6bafea12&scoped=true"
import script from "./LiabilityReport.vue?vue&type=script&lang=js"
export * from "./LiabilityReport.vue?vue&type=script&lang=js"

import "./LiabilityReport.vue?vue&type=style&index=0&id=6bafea12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JavonOnuigbo\\mgs\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bafea12"]])

export default __exports__